<template>
    <!-- 车辆管理——我的派车单 -->
    <div class="email-wrap module-layout">
        <BlockFrame :header="{ title: appletData.name, icon: appletData.icon, more: true, code: 'beforeSendcar' }">
            <div ref="vehicleContent" class="email-content">
                <div v-if="listdata.length > 0" class="">
                    <vehicleList :datalist="listdata" :applet-data="appletData" />
                </div>
                <div v-if="listdata.length <= 0" style="text-align: center; margin: 30px">
                    <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                    <br />
                    <span v-text-lbl="'common.noData'" style="font-size: var(--portalFontSize15); color: #dbdbdb">暂无数据</span>
                </div>
            </div>
        </BlockFrame>
    </div>
</template>
<script>
import vehicleList from './vehicleList'

export default {
    name: 'Email',
    components: { vehicleList },
    props: {
        appColumns: {
            type: String,
            required: true
        },
        appletData: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            listdata: [],
            pageSize: 5
        }
    },
    created() {
        debugger
        this.$options.components['BlockFrame'] = this.$loadComponent('@/wapp/common/components/BlockFrame/index')

        this.$nextTick(() => {
            this.pageSize = parseInt(this.$refs.vehicleContent.clientHeight / 100)
            this.getEmail()
        })
    },
    methods: {
        async getEmail() {
            const params = {
                pageSize: this.pageSize,
                pageNum: 1,
                orderBy: 'flStartTime desc',
                urlsearch: `orgCode:${this.loginUser.orgCode};creatorId:${this.loginUser.personId}`
            }
            const res = await this.$app.listdata('/clgl/sendcar/listdata', params)
            if (res.code === 'success') {
                this.listdata = res.body.pageInfo.list
            }
        },
        onMoreClick() {
            if (this.appletData.url.indexOf('?') > 1 && this.appletData.url.split('?')[1].indexOf('productCode') > -1) {
                const search = this.appletData.url.split('?')[1]
                if (search.indexOf('&') > -1) {
                    const searchary = search.split('&')
                    searchary.forEach((item) => {
                        if (item.indexOf('productCode') > -1) {
                            this.$bus.emit('redirectMoreClick', item.split('=')[1])
                        }
                    })
                } else {
                    this.$bus.emit('redirectMoreClick', search.split('=')[1])
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.module-layout {
    width: 100%;
    height: 100%;
    .email-content {
        height: calc(100% - 50px);
    }
}
</style>
